import React, { useMemo } from 'react';
import { Box, Flex, Icon, Tag, Text, IconName, Popover } from '@televet/kibble-ui';
import { SmsNotificationStatusType } from 'shared/types/graphql';
import { TypographyVariant } from '@televet/kibble-ui/build/shared/types/typography';

interface IMassTextAlertStatusTagProps {
  status: SmsNotificationStatusType;
  count: number;
  iconName: IconName;
  iconVariant: TypographyVariant;
}

const MassTextAlertStatusTag = ({
  status,
  count,
  iconName,
  iconVariant,
}: IMassTextAlertStatusTagProps): JSX.Element => {
  const popoverText = useMemo(() => {
    const alertText = `${count} of your alerts `;

    switch (status) {
      case SmsNotificationStatusType.Delivered:
        return (
          <Text>
            {`${alertText} were `}
            <Text fontWeight={600}>delivered</Text>
          </Text>
        );
      case SmsNotificationStatusType.Error:
        return (
          <Text>
            {`${alertText} were `}
            <Text fontWeight={600}>not delivered</Text>
          </Text>
        );
      case SmsNotificationStatusType.Sent:
        return <Text>{`${alertText} did not receive a status update from your carrier`}</Text>;
    }
  }, [count, status]);

  return (
    <Popover
      trigger="hover"
      boundary="scrollParent"
      placement="bottom-start"
      variant="default"
      isLazy
      anchor={
        <Box display="inline-block">
          <Tag
            label={`${count}`}
            leftElement={<Icon name={iconName} size="xs" variant={iconVariant} />}
            size="sm"
            mt={2}
            mr={1}
          />
        </Box>
      }
    >
      <Flex>
        <Box>
          <Icon name={iconName} size="lg" variant={iconVariant} />
        </Box>
        <Text pl={1}>{popoverText}</Text>
      </Flex>
    </Popover>
  );
};

export default MassTextAlertStatusTag;
